module.exports = __webpack_public_path__ + "static/village_bnM@2x-7ede6c041f86af3552975091af478a19.png";